<template>
  <div v-bind="$attrs">
    <slot />
  </div>
</template>
